/**
 * Module-Aware Navigation Links
 * 
 * This file organizes navigation links by module/product line.
 * Each module has its own set of navigation items.
 */

import { MODULE_IDS } from "../../../config/modules";
import {
  dashboardLink,
  agentsLink,
  // userManagementLink,
  insuranceLink,
  providersLink,
  purchasesLink,
  paymentsLink,
  analyticsLink,
  reportsLink,
  organizerManagementLink,
  eventsLink,
  // toursLink,
  conferencesLink,
  tradeMissionsLink,
  // teamsLink,
} from "./mainNavLinks";

/**
 * Navigation links organized by module
 * 
 * Structure:
 * - Common: Links available in all modules (Dashboard, Settings, etc.)
 * - Module-specific: Links only shown when that module is active
 */
export const MODULE_NAV_LINKS = {
  // Common links available in all modules
  common: [
    dashboardLink,
    // Add other common links here (Settings, Help, etc.)
  ],

  // Insurance Module Navigation
  [MODULE_IDS.INSURANCE]: [
    agentsLink,
    insuranceLink,
    providersLink,
    purchasesLink,
    // analyticsLink, // Hidden
    // reportsLink, // Hidden
  ],

  // Events & Media Module Navigation
  [MODULE_IDS.EVENTS_MEDIA]: [
    organizerManagementLink,
    eventsLink,
    // toursLink,
    conferencesLink,
    tradeMissionsLink,
    // teamsLink,
  ],

  // Travel, Tours & Logistics Module Navigation
  [MODULE_IDS.TRAVEL_TOURS]: [
    // Add travel-specific links here
    // toursLink,
    // transportationLink,
    // bookingsLink,
    analyticsLink,
    reportsLink,
  ],

  // Safety Services Module Navigation
  [MODULE_IDS.SAFETY_SERVICES]: [
    // Add safety-specific links here
    analyticsLink,
    reportsLink,
  ],
};

/**
 * Get navigation links for a specific module
 * @param {string} moduleId - The module ID
 * @returns {Array} Array of navigation links
 */
export const getNavLinksForModule = (moduleId) => {
  const commonLinks = MODULE_NAV_LINKS.common || [];
  const moduleLinks = MODULE_NAV_LINKS[moduleId] || [];
  
  // Combine common links with module-specific links
  return [...commonLinks, ...moduleLinks];
};

/**
 * Get all available navigation links (for admin with access to all modules)
 * @returns {Array} Array of all navigation links
 */
export const getAllNavLinks = () => {
  const allLinks = new Set();
  
  // Add common links
  MODULE_NAV_LINKS.common.forEach(link => allLinks.add(link));
  
  // Add all module-specific links
  Object.values(MODULE_NAV_LINKS).forEach(links => {
    if (Array.isArray(links)) {
      links.forEach(link => allLinks.add(link));
    }
  });
  
  return Array.from(allLinks);
};

